import { Component, Input, OnInit } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { CheckDto, CheckItemDto } from "src/app/shared/models/check-dto";

@Component({
	selector: "app-customer-bio-detail",
	templateUrl: "./customer-bio-detail.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class CustomerBioDetailComponent implements OnInit {
	@Input() customerChecks: CheckDto[];
	@Input() venueKey: number;

	customerTags: string[];

	moment: any = moment;

	items: CheckItemDto[];

	visitDays: {
		day: number;
		count: number;
	}[];
	constructor(public app: AppService, private focuslink: FocuslinkService, public customerService: CustomerService) {}

	ngOnInit(): void {
		if (this.customerChecks) {
			const items: CheckItemDto[] = [];
			this.visitDays = [];
			for (let i = 0; i !== 7; i++) {
				this.visitDays.push({ day: i, count: 0 });
			}

			this.customerChecks.forEach((check) => {
				const visitDay = moment(check.created).day();
				const d = this.visitDays.find((i) => i.day === visitDay);
				d.count += 1;
				check.seats.forEach((seat) =>
					seat.items.forEach((i) => {
						if (items.some((n) => n.menuItemKey === i.menuItemKey)) {
							const itm = items.find((n) => n.menuItemKey === i.menuItemKey);
							itm.quantity += i.quantity;
						} else {
							items.push(i);
						}
					})
				);
			});

			items.sort((a, b) => (a.quantity < b.quantity ? 1 : -1));
			this.items = items;
			this.visitDays.sort((a, b) => (a.count < b.count ? 1 : -1));
			this.visitDays = this.visitDays;
		}
	}

	tagAdd(event) {
		if (!this.customerService.customer.value.tags) {
			this.customerService.customer.value.tags = [];
		}
		if (!this.customerService.customer.value.tags.some((i) => i === event.value)) {
			this.customerService.customer.value.tags.push(event.value);
		}
		this.customerService.save();
	}

	tagRemove(tagString: string) {
		this.customerService.customer.value.tags.splice(
			this.customerService.customer.value.tags.findIndex((i) => i === tagString),
			1
		);
		this.customerService.save();
	}
}
